import React, { useState } from "react"
import { AvGroup } from "availity-reactstrap-validation"
import { Label } from "reactstrap"
import DatePicker from "react-datepicker"

const Time = ({ item, disabled, updateValue, value }) => {
  const [time, setTime] = useState(value)

  return (
    <AvGroup>
      <Label>{item.Label}</Label>
      <div className="mb-3">
        <DatePicker
          selected={time}
          onChange={val => {
            setTime(val)
            updateValue(val)
          }}
          placeholderText={time}
          showTimeSelect
          showTimeSelectOnly
          timeIntervals={5}
          timeCaption="Time"
          dateFormat="h:mm aa"
          disabled={disabled}
        />
      </div>
    </AvGroup>
  )
}

export default Time
